interface IProps {
	className?: string
	color?: string
}
export const Triangle = ({ className, color }: IProps) => {
	return (
		<svg
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width='19'
			height='16'
			viewBox='0 0 19 16'
			fill='none'
		>
			<path
				d='M9.5 0L18.5933 15.75H0.406734L9.5 0Z'
				fill={!color ? '#F85A5A' : color}
			/>
		</svg>
	)
}
export const Star = ({ className, color }: IProps) => {
	return (
		<svg
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width='22'
			height='22'
			viewBox='0 0 22 22'
			fill='none'
		>
			<path
				d='M11 0C11.2148 5.98391 16.0161 10.7852 22 11C16.0161 11.2148 11.2148 16.0161 11 22C10.7852 16.0161 5.98391 11.2148 0 11C5.98391 10.7852 10.7852 5.98391 11 0Z'
				fill={'#F85A5A'}
			/>
		</svg>
	)
}
export const Oval = ({ className, color }: IProps) => {
	return (
		<svg
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width='248'
			height='52'
			viewBox='0 0 248 52'
			fill='none'
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M41.182 22.9638C15.8244 28.8079 -1.42358 38.3029 2.37858 44.2415C6.81332 51.2516 17.2251 50.9777 119.667 40.8393C218.514 31.0644 247.462 25.9351 246.798 18.3501C246.139 10.8137 236.144 6.88679 216.962 6.60517C198.174 6.33815 208.481 11.0218 217.76 11.2388C228.952 11.4845 230.967 11.5532 234.001 12.0717C239.468 12.9652 241.143 14.1905 239.872 16.4574C235.438 24.5864 131.591 33.7699 69.9368 40.8297C19.728 46.5452 2.27209 46.9455 7.48927 42.1776C29.9978 21.6886 160.023 9.87192 190.296 8.69318C210.851 7.87474 203.402 6.17472 182.553 6.43096C182.5 6.38659 97.372 10.0128 41.182 22.9638Z'
				fill={!color ? '#ECECEC' : color}
			/>
		</svg>
	)
}
export const Arrow = ({ className }: IProps) => {
	return (
		<svg
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width='63'
			height='54'
			viewBox='0 0 63 54'
			fill='none'
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M0.669561 13.2399C0.622031 34.6083 13.883 43.3405 42.0207 40.4857C46.441 40.0239 46.441 39.9819 42.9238 42.165C38.9312 44.6419 30.3759 51.9887 30.8037 52.6184C31.9918 54.2976 35.6992 52.7447 41.1652 48.3367C46.346 44.1385 52.5249 40.4437 56.8026 39.0164C64.1698 36.5395 64.8827 34.3144 58.6087 33.4748C53.6181 32.8031 50.3385 31.4601 42.4485 26.7162C36.0319 22.8537 34.606 22.5178 31.5642 23.9032C27.4291 25.7923 29.7579 28.3111 41.1176 34.2305C44.7775 36.1196 44.3972 36.3296 36.6023 36.3296C15.071 36.3296 4.94714 23.5673 9.31992 2.07277C10.0329 -1.32773 0.717091 -2.29327 0.669561 13.2399Z'
				fill='#ECECEC'
			/>
		</svg>
	)
}
export const DbStar = ({ className }: IProps) => {
	return (
		<svg
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width='18'
			height='19'
			viewBox='0 0 18 19'
			fill='none'
		>
			<path
				d='M9.71937 6.98594C8.5125 6.18331 7.55666 5.14782 6.92908 3.97142C6.44634 3.0646 5.75118 1.39191 5.75118 1.12844C5.75118 0.717929 4.59258 0.552503 4.59258 1.34903C4.59258 1.75954 4.16776 4.14298 2.87401 5.5706C1.64782 6.9308 1.17473 7.2801 0.315437 7.51293C-0.176966 7.6416 -0.099736 7.73958 0.595422 7.89275C2.31401 8.27263 3.08642 9.18557 4.64086 12.6658C5.54842 14.6877 6.10841 14.6264 6.58151 12.4513C7.04495 10.2885 8.76353 7.83148 9.98971 7.56189C10.3952 7.47611 10.3663 7.42097 9.71937 6.98594ZM5.66428 10.895L5.48084 11.4465C5.4036 11.3178 4.39948 8.61575 2.63263 7.89275C2.14988 7.69669 2.06299 7.61703 2.34298 7.61703C3.24089 7.61703 4.64086 6.10365 5.06568 4.6454C5.26843 3.97754 5.29739 3.95303 5.54842 4.36968C6.06979 5.25811 6.92908 6.09752 8.10699 6.87565L8.87939 7.39039C8.77318 7.47004 6.60082 8.00917 5.66428 10.895Z'
				fill='white'
			/>
			<path
				d='M16.6807 14.2037C15.1648 13.4194 14.0545 12.0286 14.0545 10.8829C14.0545 10.3804 13.0021 9.80443 12.6063 11.232C12.1235 13.0028 11.8049 13.4868 10.7139 14.1792C9.81597 14.7429 9.80632 14.7061 10.936 14.9022C11.9883 15.086 12.7704 15.9684 13.2821 17.5553C13.6007 18.5417 14.7497 18.5846 14.7979 17.5797C14.8655 16.1644 15.3772 15.374 16.5358 14.9083C17.2696 14.6081 17.2889 14.5162 16.6807 14.2037ZM15.5221 14.5285C15.1841 14.602 14.2669 15.1105 14.0545 15.3311C13.7649 15.6436 13.7745 15.6436 13.4366 15.3004C13.1469 15.0063 12.4614 14.6816 12.0077 14.6265C11.6601 14.5774 11.6697 14.5653 12.2297 14.216C12.5001 14.0506 12.8766 13.7135 13.0697 13.4684C13.5042 12.9354 13.4462 12.9416 13.8614 13.3643C14.18 13.6829 14.7014 14.0321 15.3579 14.363C15.5414 14.4426 15.5993 14.5101 15.5221 14.5285Z'
				fill='white'
			/>
		</svg>
	)
}

interface IBgRulingNumerProps {
	svg: {
		fillColor: string
		strokeColor: string
		strokeCover: string
	}
	number: number
}
export const BgRulingNumber = ({ svg, number }: IBgRulingNumerProps) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='122'
			height='122'
			viewBox='0 0 122 122'
			fill='none'
		>
			<rect
				x='1.12402'
				y='0.5'
				width='120.353'
				height='120.353'
				fill={svg.fillColor}
				stroke={svg.strokeColor}
			/>
			<g clipPath='url(#clip0_133_4)'>
				<path d='M60.9974 6.06766V14.1579' stroke={svg.strokeCover} />
				<path
					d='M46.9406 7.9183L49.0339 15.7355'
					stroke={svg.strokeCover}
				/>
				<path
					d='M33.8445 13.3387L37.8897 20.3469'
					stroke={svg.strokeCover}
				/>
				<path
					d='M22.5991 21.9751L28.323 27.6989'
					stroke={svg.strokeCover}
				/>
				<path
					d='M13.9628 33.2205L20.971 37.2656'
					stroke={svg.strokeCover}
				/>
				<path
					d='M8.54237 46.3165L16.3595 48.4099'
					stroke={svg.strokeCover}
				/>
				<path d='M6.69173 60.3733H14.782' stroke={svg.strokeCover} />
				<path
					d='M8.54237 74.4301L16.3595 72.3367'
					stroke={svg.strokeCover}
				/>
				<path
					d='M13.9628 87.5362L20.971 83.4911'
					stroke={svg.strokeCover}
				/>
				<path
					d='M22.5991 98.7816L28.323 93.0578'
					stroke={svg.strokeCover}
				/>
				<path
					d='M33.8445 107.408L37.8897 100.4'
					stroke={svg.strokeCover}
				/>
				<path
					d='M46.9406 112.838L49.0339 105.021'
					stroke={svg.strokeCover}
				/>
				<path d='M60.9974 114.689V106.599' stroke={svg.strokeCover} />
				<path
					d='M75.0541 112.838L72.9608 105.021'
					stroke={svg.strokeCover}
				/>
				<path
					d='M88.1603 107.408L84.1152 100.4'
					stroke={svg.strokeCover}
				/>
				<path
					d='M99.4057 98.7816L93.6819 93.0578'
					stroke={svg.strokeCover}
				/>
				<path
					d='M108.032 87.5362L101.024 83.4911'
					stroke={svg.strokeCover}
				/>
				<path
					d='M113.462 74.4301L105.645 72.3367'
					stroke={svg.strokeCover}
				/>
				<path d='M115.313 60.3733H107.223' stroke={svg.strokeCover} />
				<path
					d='M113.462 46.3165L105.645 48.4099'
					stroke={svg.strokeCover}
				/>
				<path
					d='M108.032 33.2205L101.024 37.2656'
					stroke={svg.strokeCover}
				/>
				<path
					d='M99.4057 21.9751L93.6819 27.6989'
					stroke={svg.strokeCover}
				/>
				<path
					d='M88.1603 13.3387L84.1152 20.3469'
					stroke={svg.strokeCover}
				/>
				<path
					d='M75.0541 7.9183L72.9608 15.7355'
					stroke={svg.strokeCover}
				/>
				<path
					d='M14.2763 6.06766L15.3489 12.1455L21.8609 13.1466L15.3489 14.1477L14.2763 20.2256L13.2037 14.1477L6.69173 13.1466L13.2037 12.1455L14.2763 6.06766Z'
					fill='white'
				/>
				<path
					d='M14.2763 102.139L15.3489 108.217L21.8609 109.218L15.3489 110.219L14.2763 116.297L13.2037 110.219L6.69173 109.218L13.2037 108.217L14.2763 102.139Z'
					fill='white'
				/>
				<path
					d='M108.325 6.06766L109.398 12.1455L115.91 13.1466L109.398 14.1477L108.325 20.2256L107.253 14.1477L100.741 13.1466L107.253 12.1455L108.325 6.06766Z'
					fill='white'
				/>
				<path
					d='M108.325 102.139L109.398 108.217L115.91 109.218L109.398 110.219L108.325 116.297L107.253 110.219L100.741 109.218L107.253 108.217L108.325 102.139Z'
					fill='white'
				/>
			</g>
			<rect
				x='15.282'
				y='14.6579'
				width='92.0376'
				height='92.0376'
				rx='46.0188'
				fill='#FAFAFA'
				stroke={svg.strokeCover}
			/>
			<rect
				x='7.19173'
				y='6.56766'
				width='108.218'
				height='108.218'
				rx='54.109'
				stroke={svg.strokeColor}
			/>
			<defs>
				<clipPath id='clip0_133_4'>
					<rect
						width='108.621'
						height='108.621'
						fill='white'
						transform='translate(6.69173 6.06766)'
					/>
				</clipPath>
			</defs>
		</svg>
	)
}
